@if (attachmentItem(); as attachmentItem) {
  @switch (attachmentItem.state) {
    @case ('uploading') {
      <div class="p-fileupload-filename">{{ attachmentItem.file.name }}</div>

      @if (uploading()) {
        <p-badge
          severity="warning"
          [value]="'i18n.AttachmentsManager.loading' | translate" />
      }
      <div class="p-fileupload-size">{{ attachmentItem.file.size | fileSizeFormat }}</div>

      @if (isImage()) {
        <app-image-preview [src]="{ type: 'objectURL', value: attachmentItem.file.objectURL }" />
        <!-- <img
                  [src]="file.objectURL"
                  [width]="50"
                  (error)="fileUpload?.imageError($event)" /> -->
      }

      <button
        type="button"
        appButton
        [iconPosition]="'only-icon'"
        [color]="'transparent'"
        [icon]="'close'"
        [size]="'md'"
        [pTooltip]="'i18n.AttachmentsManager.abort' | translate"
        [tooltipPosition]="'bottom'"
        [disabled]="uploading()"
        (click)="removeUploading.next($event)"></button>
    }

    @case ('uploaded') {
      <div class="p-fileupload-filename">
        @if (canEdit() && nameEditable()) {
          <app-smart-input-string
            [mode]="'composite'"
            [style]="{ '--font-size': '.9rem' }"
            [animated]="false"
            [control]="nameControl()"
            [resetValue]="initialName()" />
        } @else {
          <span>{{ attachmentItem.so.name }}</span>
        }
      </div>

      <p-badge
        severity="success"
        [value]="'i18n.AttachmentsManager.success' | translate" />

      <div class="p-fileupload-size">{{ attachmentItem.so.contentLength | fileSizeFormat }}</div>

      @if (isImage()) {
        <app-image-preview [src]="{ type: 'objectURL', value: attachmentItem.file.objectURL }" />
        <!-- <img
                  [src]="file.objectURL"
                  [width]="50"
                  (error)="fileUpload?.imageError($event)" /> -->
      }
      <!-- DOWNLOAD -->
      <button
        type="button"
        appButton
        [iconPosition]="'only-icon'"
        [color]="'transparent'"
        [icon]="'file-download'"
        [size]="'md'"
        [pTooltip]="'i18n.AttachmentsManager.download' | translate"
        [tooltipPosition]="'bottom'"
        (click)="download()"></button>

      @if (canEdit()) {
        <button
          type="button"
          appButton
          [iconPosition]="'only-icon'"
          [color]="'transparent'"
          [icon]="'delete-outline'"
          [size]="'md'"
          [pTooltip]="'i18n.AttachmentsManager.remove' | translate"
          [tooltipPosition]="'bottom'"
          [disabled]="uploading()"
          (click)="removeUploaded.next()"></button>
      }
    }

    @case ('existent') {
      <div class="p-fileupload-filename">
        @if (canEdit() && nameEditable()) {
          <app-smart-input-string
            [mode]="'composite'"
            [style]="{ '--font-size': '.9rem' }"
            [animated]="false"
            [control]="nameControl()"
            [resetValue]="initialName()" />
        } @else {
          <span>{{ attachmentItem.so.name }}</span>
        }
      </div>

      <div class="p-fileupload-size">{{ attachmentItem.so.contentLength | fileSizeFormat }}</div>

      @if (isImage()) {
        <app-image-preview
          [pTooltip]="'i18n.AttachmentsManager.show' | translate"
          [tooltipPosition]="'bottom'"
          [src]="{ type: 'dto', value: attachmentItem.so }" />
        <!-- <img
              [src]="file.objectURL"
              [width]="50"
              (error)="fileUpload?.imageError($event)" /> -->
      }

      <!-- DOWNLOAD -->
      <button
        type="button"
        appButton
        [iconPosition]="'only-icon'"
        [color]="'transparent'"
        [icon]="'file-download'"
        [size]="'md'"
        [pTooltip]="'i18n.AttachmentsManager.download' | translate"
        [tooltipPosition]="'bottom'"
        (click)="download()"></button>

      @if (canEdit()) {
        <button
          type="button"
          appButton
          [iconPosition]="'only-icon'"
          [color]="'transparent'"
          [icon]="'delete-outline'"
          [size]="'md'"
          [pTooltip]="'i18n.AttachmentsManager.remove' | translate"
          [tooltipPosition]="'bottom'"
          (click)="removeExistent.next()"></button>
      }
    }
  }
}
